/**
 * Pure admission logic for the bulk-upload concurrency gate (see
 * UploadManagerProvider / MAX_CONCURRENT_UPLOADS). Extracted so the load-bearing
 * invariant — "never more than `max` uploads active at once, refill FIFO as
 * slots free" — is unit-testable without React/tus.
 *
 * `active` is the live set of in-flight ids (mutated: each admitted item is
 * added). `pending` is the FIFO queue (mutated: admitted items are shifted off).
 * `start` is invoked once per admitted item, in order. Caller removes an id from
 * `active` when it reaches a terminal state and calls this again to refill.
 */
export function admitUploads<T extends { id: string }>(
  active: Set<string>,
  pending: T[],
  max: number,
  start: (item: T) => void,
): void {
  while (active.size < max && pending.length > 0) {
    const next = pending.shift()!
    active.add(next.id)
    start(next)
  }
}
